import React from 'react'
import { Icon, IconRef } from '../Icon'
import './ICSActionIcon.css'

interface ICSActionIconProps {
  column?
  data?
  icon: IconRef
  title: string
  onClick?: React.MouseEventHandler<HTMLElement>
  renderData
  disabled?: boolean
}

export const ICSActionIcon = (props: ICSActionIconProps) => {
  const { icon, title, onClick, disabled } = props

    return (
      <button
        type="button"
        className={`ics-action-icon-button ics-action-icon ${
          disabled ? 'disabled' : ''
        }`}
        title={title}
        aria-label={title}
        disabled={disabled}
        onClick={disabled ? undefined : onClick}
      >
        <Icon use={icon} className="icon-sm ics-action-icon-svg" />
      </button>
    )
  
}
